import { render, staticRenderFns } from "./VolumeRanking.vue?vue&type=template&id=1580ad5c&scoped=true"
import script from "./VolumeRanking.vue?vue&type=script&lang=js"
export * from "./VolumeRanking.vue?vue&type=script&lang=js"
import style0 from "./VolumeRanking.vue?vue&type=style&index=0&id=1580ad5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1580ad5c",
  null
  
)

export default component.exports